import { render, staticRenderFns } from "./Son_CheckBox.vue?vue&type=template&id=6edaeaeb&scoped=true&"
import script from "./Son_CheckBox.vue?vue&type=script&lang=js&"
export * from "./Son_CheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edaeaeb",
  null
  
)

export default component.exports